import UploadImage from '@/components/UploadImage'
import { createCustomer, updateCustomer } from '@/utils/customerApi'

export default {
  components: { UploadImage },
  props: {
    customer: {
      type: Object,
      required: true,
      default () { return {} }
    }
  },
  computed: {
    adUser () {
      return this.$store.state.customer.userInfo
    },
    auditState () { // 客户审核状态(-2:未提交资料(即游客客户,由前端定义的值),-1:审核中,0:审核未通过,1:审核通过(生效),2:认证已过期)
      if (!this.isEmpty(this.customer) && this.customer.advertiserType) return this.customer.checkStatus
      return -2
    },
    reason () {
      if (this.auditState === 0) return (this.customer.checkMessage || '')
      return ''
    }
  },
  watch: {
    customer: {
      immediate: true,
      handler (v) {
        if (!this.isEmpty(v) && v.advertiserType) { // 个人(1)或企业(1)客户
          for(let key in this.formData) this.formData[key] = v[key]
        } else { // 初次提交资料
          this.formData.advertiserType = this.adType
        }
      }
    }
  },
  methods: {
    inputPhone (v) {
      // 联系电话仅支持输入数字,'+','(',')','-'
      this.formData.contactPhone = v.replace(/[^\d\+\(\)-]/g, '')
    },
    async saveInfo () {
      let tip = ''
      if (this.auditState === -1) tip = '是否重新提交审核？重新提交后会改变原来的审核内容'
      if (this.auditState === 1) tip = '审核内容已通过，是否需要更新审核内容'
      if (tip) { // 审核中|审核通过状态重新提交需二次确认
        this.$confirm(tip, '提示', {
          confirmButtonText: '是',
          cancleButtonText: '否',
          type: 'warning'
        }).then(() => {
          this.actualSubmit(true)
        })
      } else {
        this.actualSubmit(this.auditState >= -1)
      }
    },
    async actualSubmit (update) { // update: Boolean true为更新客户资料(重新提交), false为初次提交(新增客户)
      const {
        businessLicenseUrl, cardFrontUrl, cardBackUrl, userCardUrl,
        customerName, legalPerson, companyType, contacter, contactPhone
      } = this.formData
      if (this.adType === 1) {
        if (!cardFrontUrl) return this.$message.warning('请上传认证人身份证正面')
        if (!cardBackUrl) return this.$message.warning('请上传认证人身份证反面')
        if (!userCardUrl) return this.$message.warning('请上传认证人手持身份证照')
        if (!customerName || customerName.trim().length == 0) return this.$message.warning('请填写认证人姓名')
        if (!contacter || contacter.trim().length == 0) return this.$message.warning('请填写联系人姓名')
        if (!contactPhone) return this.$message.warning('请填写联系人电话')
      } else {
        if (!businessLicenseUrl) return this.$message.warning('请上传营业执照')
        if (!cardFrontUrl) return this.$message.warning('请上传法人身份证正面')
        if (!cardBackUrl) return this.$message.warning('请上传法人身份证反面')
        if (!customerName || customerName.trim().length == 0) return this.$message.warning('请填写公司名称')
        if (!legalPerson || legalPerson.trim().length == 0) return this.$message.warning('请填写法人姓名')
        if (!companyType) return this.$message.warning('请选择企业验证类型')
        if (!contacter || contacter.trim().length == 0) return this.$message.warning('请填写联系人姓名')
        if (!contactPhone) return this.$message.warning('请填写联系人电话')
      }
      const { customerType } = this.customer
      const { id: creatorId, userName: creatorName, customerId } = this.adUser
      const cusId = customerId === 0 ? undefined : customerId
      const param = { ...this.formData, creatorId, creatorName, customerId: cusId, customerType }
      const res =update ? await updateCustomer(param) : await createCustomer(param)
      if (res && res.code === 0) {
        this.$message.success('保存成功')
        // 更新用户数据
        this.$store.dispatch('customer/getUserInfo')
        /**
         * 若是第一次提交客户资料,则生成新的客户,更新用户数据后
         * 触发layout中的watch获取用户关联的客户最新信息。
         * 若是更新原来的客户资料(已生成的客户其id存在且不变)则需调用一次接口
         */
        if (cusId) this.$store.dispatch('customer/getCustomerInfo', cusId) // 获取用户关联的客户信息
      }
    }
  }
}